import React from 'react'
import ProveedoresTable from './ProveedoresTable'

const Proveedores = () => {
  return (
    <div>
      <ProveedoresTable />
    </div>
  )
}

export default Proveedores